import { SET_PROJECTS } from '../actions/projects';

export const projectsReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_PROJECTS:
      return {
        ...state,
        projects: payload,
      };
    default:
      return undefined;
  }
};
